module.exports = __webpack_public_path__ + "static/media/a27.c64c5fa2.pdf";